// ── units.js — 단위·규격 한→중 변환 (V112) ─────────────────────────────────
//
// 단위는 종류가 적어서 API 없이 고정 표로 바꾼다 — 비용 0, 오프라인에서도 동작.
// 규격("3kg/팩", "30개/판", "10개입")은 숫자·영문 단위는 그대로 두고
// 한글 덩어리만 이 표(없으면 용어집)로 치환한다.
// 표로 못 바꾸는 한글이 남으면 null → 호출하는 쪽이 spec_zh(AI 번역)를 쓴다.

import { lookupGlossary } from './glossary';

export const UNIT_ZH = {
  // 포장·용기
  '통': '桶', '병': '瓶', '캔': '罐', '팩': '包', '봉': '袋', '봉지': '袋', '봉투': '袋',
  '포': '袋', '포대': '袋', '망': '网袋', '박스': '箱', '상자': '箱', '짝': '箱', '판': '板',
  '롤': '卷', '세트': '套', '컵': '杯', '팔레트': '托盘', '케이스': '盒', '곽': '盒', '갑': '盒',
  // 개수
  '개': '个', '개입': '个装', '입': '入', '구': '枚', '알': '粒', '장': '张', '매': '张',
  '마리': '只', '모': '块', '덩이': '块', '덩어리': '块', '조각': '块', '토막': '段',
  '줄': '条', '뿌리': '根', '포기': '棵', '송이': '串', '단': '把', '묶음': '捆',
  '켤레': '双', '공기': '碗', '그릇': '碗', '접시': '盘', '인분': '人份',
  // 무게·부피 (한글로 적은 경우)
  '그램': '克', '킬로': '公斤', '킬로그램': '公斤', '근': '斤', '리터': '升', '미리': '毫升',
  '밀리리터': '毫升', '되': '升', '말': '斗',
};

const HANGUL = /[가-힣]/;
const HANGUL_RUN = /[가-힣]+/g;

function lookup(word) {
  const w = String(word || '').trim();
  if (!w) return null;
  return UNIT_ZH[w] || lookupGlossary(w) || null;
}

/**
 * 단위 한 단어 → 중국어. 한글이 없거나("kg", "L") 표에 없으면 null.
 */
export function unitToZh(unit) {
  const u = String(unit || '').trim();
  if (!u || !HANGUL.test(u)) return null;
  return lookup(u);
}

/**
 * 규격 문자열 → 중국어. 한글이 없으면 null(바꿀 게 없음).
 * 한글 덩어리를 전부 바꿀 수 있을 때만 결과를 돌려주고, 하나라도 못 바꾸면 null.
 *   "3kg/팩" → "3kg/包",  "30개/판" → "30个/板",  "1박스(20개입)" → "1箱(20个装)"
 */
export function specToZh(spec) {
  const s = String(spec || '').trim();
  if (!s || !HANGUL.test(s)) return null;
  let ok = true;
  const out = s.replace(HANGUL_RUN, (run) => {
    const hit = lookup(run);
    if (hit) return hit;
    ok = false;
    return run;
  });
  return ok ? out : null;
}

export function hasHangul(v) {
  return HANGUL.test(String(v || ''));
}
